import React, { FunctionComponent } from "react";
import ChannelsContent from "./ChannelsContent";
import HomeContent from "./HomeContent";
import MepContent from "./MepContent";
import NewshubContext from "./NewshubContext";
import NewshubUi from "./NewshubUi";
import TimelineContent from "./TimelineContent";
import { I18nProvider } from "../../service/translation";
import { Route, Switch } from "react-router";
import { ThemeOptions } from "@material-ui/core";
import SearchContent from "./SearchContent";
import CookiesContent from "./CookiesContent";
import DataProtectionNoticeContent from "./DataProtectionNoticeContent";
import EmbedContent from "./EmbedContent";
import ErrorContent from "./ErrorContent";

interface NewshubProps {
    i18nProvider: I18nProvider;
    theme?: ThemeOptions;



}

/**
 * Main app component, entry point to the application.
 *
 * Just a wrapper which initializes the several service contexts
 * (translation, router, theme, filters) and defines the
 * main routes, to save you a few typings.
 */
const Newshub: FunctionComponent<NewshubProps> = ({
    i18nProvider,
    theme,
}) => {
    if (process.env.NODE_ENV === "production") {
        // Production checks go here
    }
    return (
        <NewshubContext
            i18nProvider={i18nProvider}
            theme={theme}


        >
            <NewshubUi>
                <Switch>
                    <Route exact path="/channels/:section?/:group?" component={ChannelsContent} />
                    <Route exact path="/embed/tw/:id" component={EmbedContent} />
                    <Route exact path="/contributors/:id" component={MepContent} />
                    <Route exact path="/cookies" component={CookiesContent} />
                    <Route exact path="/data-protection-notice" component={DataProtectionNoticeContent} />
                    <Route exact path="/search" component={SearchContent} />
                    <Route exact path="/timeline" component={TimelineContent} />
                    <Route exact path="/tw/:id" component={EmbedContent} />
                    <Route exact path="/" component={HomeContent} />
                    <Route component={ErrorContent} />
                </Switch>
            </NewshubUi>
        </NewshubContext>
    );
};

export default Newshub;
